// extracted by mini-css-extract-plugin
module.exports = {"userTable":"Table_userTable__f3U5M","userTableProfile":"Table_userTableProfile__CR7ub","delete":"Table_delete__AA4ae","rote":"Table_rote__Wfvy8","edit":"Table_edit__3Ke07"};